import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

/* eslint-disable no-new */
let plusApp = {
  mount:() => {
    new Vue({
      el: '#app-2021-04-hallituspaikat',
      render: h => h(App)
    })
  }
}

plusApp.projectName = 'app-2021-04-hallituspaikat'
if (window.plusApp === undefined) {
  window.plusApp = {}
}
if (window.plusApp[plusApp.projectName] === undefined) {
  window.plusApp[plusApp.projectName] = plusApp
  window.plusApp[plusApp.projectName].mount()
}